// Wayflyer app sidebar icons — exact filled vectors from Figma NavMenu
// (node 5663:23089). Generated 1:1 from the Figma SVG assets.
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

export function AppGetStarted(props: IconProps) {
  return (
    <svg
      viewBox="0 0 12.5849 12.5842"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M9.17804 11.5451C9.46491 11.5451 9.69747 11.7778 9.69759 12.0647C9.69759 12.3516 9.46498 12.5842 9.17804 12.5842H3.40549C3.11863 12.5841 2.88594 12.3515 2.88594 12.0647C2.88606 11.7779 3.1187 11.5452 3.40549 11.5451H9.17804Z"
        fill="currentColor"
      />
      <path
        d="M7.6566 3.90474C7.8595 3.70185 8.18838 3.70185 8.39128 3.90474C8.59395 4.10766 8.5941 4.4366 8.39128 4.63942L6.08239 6.94831C5.98501 7.04569 5.85276 7.10046 5.71505 7.10052C5.57736 7.10052 5.44513 7.0456 5.34771 6.94831L4.19293 5.79353C3.99003 5.59063 3.99003 5.26175 4.19293 5.05885C4.39583 4.85595 4.72471 4.85595 4.92761 5.05885L5.71505 5.84629L7.6566 3.90474Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9106 0C11.8351 9.17914e-05 12.5849 0.749806 12.5849 1.67433V9.17872C12.5848 10.1031 11.835 10.853 10.9106 10.8531H1.67433C0.749822 10.8531 0.000120358 10.1032 0 9.17872V1.67433C0 0.749749 0.749748 0 1.67433 0H10.9106ZM1.67433 1.0391C1.32363 1.0391 1.0391 1.32363 1.0391 1.67433V9.17872C1.03922 9.52932 1.3237 9.81395 1.67433 9.81395H10.9106C11.2611 9.81386 11.5457 9.52927 11.5458 9.17872V1.67433C11.5458 1.32368 11.2612 1.03919 10.9106 1.0391H1.67433Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppOverview(props: IconProps) {
  return (
    <svg
      viewBox="0 0 11.4301 11.4301"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M5.71505 4.61845C6.00199 4.61845 6.2346 4.85106 6.2346 5.138V8.02461C6.23436 8.31135 6.00184 8.54416 5.71505 8.54416C5.42826 8.54416 5.19574 8.31135 5.1955 8.02461V5.138C5.1955 4.85106 5.42811 4.61845 5.71505 4.61845Z"
        fill="currentColor"
      />
      <path
        d="M8.02394 2.88662C8.31088 2.88662 8.54349 3.11923 8.54349 3.40617V8.02461C8.54324 8.31135 8.31073 8.54416 8.02394 8.54416C7.73725 8.54404 7.50463 8.31127 7.50439 8.02461V3.40617C7.50439 3.1193 7.7371 2.88674 8.02394 2.88662Z"
        fill="currentColor"
      />
      <path
        d="M3.40617 5.77255C3.69293 5.77268 3.92559 6.00534 3.92572 6.2921V8.02394C3.92572 8.3108 3.693 8.54337 3.40617 8.54349C3.11923 8.54349 2.88662 8.31088 2.88662 8.02394V6.2921C2.88674 6.00527 3.1193 5.77255 3.40617 5.77255Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5642 0C11.0425 2.48434e-07 11.4301 0.387701 11.4301 0.865917V10.5642C11.4301 11.0424 11.0424 11.4301 10.5642 11.4301H0.865917C0.387701 11.4301 2.48432e-07 11.0425 0 10.5642V0.865917C0 0.387685 0.387685 0 0.865917 0H10.5642ZM1.0391 10.391H10.391V1.0391H1.0391V10.391Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppBank(props: IconProps) {
  return (
    <svg
      viewBox="0 0 11.4295 10.2755"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M9.75554 9.23638C10.0423 9.2366 10.2751 9.46914 10.2751 9.75593C10.2751 10.0427 10.0423 10.2753 9.75554 10.2755H1.67342C1.38662 10.2753 1.15391 10.0428 1.15387 9.75593C1.15389 9.46909 1.38661 9.23652 1.67342 9.23638H9.75554Z"
        fill="currentColor"
      />
      <path
        d="M2.25115 4.61793C2.53781 4.61817 2.77057 4.8508 2.7707 5.13748V8.0241C2.77055 8.31076 2.5378 8.54341 2.25115 8.54365C1.96431 8.54365 1.73176 8.31091 1.7316 8.0241V5.13748C1.73174 4.85066 1.9643 4.61793 2.25115 4.61793Z"
        fill="currentColor"
      />
      <path
        d="M4.56004 4.61793C4.84677 4.61808 5.07945 4.85075 5.07959 5.13748V8.0241C5.07943 8.31082 4.84676 8.5435 4.56004 8.54365C4.27319 8.54365 4.04064 8.31091 4.04049 8.0241V5.13748C4.04063 4.85066 4.27318 4.61793 4.56004 4.61793Z"
        fill="currentColor"
      />
      <path
        d="M6.86893 4.61793C7.1557 4.61803 7.38834 4.85072 7.38848 5.13748V8.0241C7.38832 8.31085 7.15569 8.54355 6.86893 8.54365C6.5822 8.54351 6.34953 8.31082 6.34938 8.0241V5.13748C6.34951 4.85074 6.58218 4.61807 6.86893 4.61793Z"
        fill="currentColor"
      />
      <path
        d="M9.17849 4.61793C9.46514 4.61817 9.6979 4.8508 9.69804 5.13748V8.0241C9.69788 8.31076 9.46513 8.54341 9.17849 8.54365C8.89164 8.54365 8.65909 8.31091 8.65894 8.0241V5.13748C8.65907 4.85066 8.89163 4.61793 9.17849 4.61793Z"
        fill="currentColor"
      />
      <path
        d="M5.44422 0.0759282C5.61032 -0.0252475 5.81937 -0.0253713 5.98542 0.0759282L11.1809 3.25141C11.4254 3.40105 11.5027 3.72042 11.3534 3.96511C11.2039 4.2098 10.8845 4.28686 10.6397 4.13762L5.71482 1.12856L0.789918 4.13762C0.545167 4.28709 0.225865 4.20974 0.0762128 3.96511C-0.0732994 3.72029 0.00392494 3.401 0.24872 3.25141L5.44422 0.0759282Z"
        fill="currentColor"
      />
      <path
        d="M6.86893 2.8861C7.15566 2.88624 7.38834 3.11891 7.38848 3.40565C7.38844 3.69247 7.15572 3.92506 6.86893 3.9252H4.56004C4.27312 3.9252 4.04052 3.69256 4.04049 3.40565C4.04063 3.11883 4.27318 2.8861 4.56004 2.8861H6.86893Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppCards(props: IconProps) {
  return (
    <svg
      viewBox="0 0 12.5849 9.98713"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.17872 0C10.1032 9.14225e-05 10.8531 0.749805 10.8531 1.67433V2.0207H10.9106C11.8351 2.02079 12.5849 2.7705 12.5849 3.69503V8.3128C12.5848 9.23722 11.835 9.98704 10.9106 9.98713H3.40617C2.48166 9.98713 1.73196 9.23728 1.73183 8.3128V7.96644H1.67433C0.749748 7.96644 0 7.21669 0 6.2921V1.67433C0 0.749748 0.749749 0 1.67433 0H9.17872ZM10.8531 6.2921C10.8531 7.21663 10.1032 7.96634 9.17872 7.96644H2.77093V8.3128C2.77106 8.6634 3.05554 8.94803 3.40617 8.94803H10.9106C11.2611 8.94794 11.5457 8.66334 11.5458 8.3128V5.03923H10.8531V6.2921ZM1.67433 1.0391C1.32363 1.0391 1.0391 1.32363 1.0391 1.67433V6.2921C1.0391 6.64281 1.32363 6.92734 1.67433 6.92734H9.17872C9.52935 6.92724 9.81395 6.64275 9.81395 6.2921V3.0598H2.54025C2.25338 3.0598 2.02082 2.82708 2.0207 2.54025C2.0207 2.25331 2.25331 2.0207 2.54025 2.0207H9.81395V1.67433C9.81395 1.32368 9.52935 1.03919 9.17872 1.0391H1.67433ZM10.8531 4.00013H11.5458V3.69503C11.5458 3.34438 11.2612 3.05989 10.9106 3.0598H10.8531V4.00013Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppTransactions(props: IconProps) {
  return (
    <svg
      viewBox="0 0 10.2752 10.276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M2.25127 5.77323C2.53819 5.77325 2.77082 6.00585 2.77082 6.29278V8.50222L3.61577 7.65728C3.81867 7.4544 4.14755 7.45439 4.35045 7.65728C4.55324 7.86017 4.55329 8.18909 4.35045 8.39195L2.61861 10.1238C2.42841 10.3138 2.12719 10.326 1.92317 10.1596L1.88394 10.1238L0.152101 8.39195C-0.050748 8.1891 -0.0506528 7.86018 0.152101 7.65728C0.355 7.4544 0.683887 7.45439 0.886778 7.65728L1.73172 8.50222V6.29278C1.73172 6.00586 1.96436 5.77326 2.25127 5.77323Z"
        fill="currentColor"
      />
      <path
        d="M7.69573 0.116358C7.8997 -0.0500134 8.20093 -0.0377495 8.39117 0.152212L10.123 1.88405C10.3259 2.08694 10.3259 2.41583 10.123 2.61872C9.9201 2.82156 9.59121 2.82158 9.38832 2.61872L8.54338 1.77378V9.75577C8.54338 10.0427 8.31075 10.2753 8.02383 10.2753C7.73703 10.2752 7.50428 10.0426 7.50428 9.75577V1.77378L6.65933 2.61872C6.45644 2.82156 6.12754 2.82158 5.92465 2.61872C5.72204 2.41582 5.7219 2.08686 5.92465 1.88405L7.65649 0.152212L7.69573 0.116358Z"
        fill="currentColor"
      />
      <path
        d="M2.25127 2.88662C2.5382 2.88664 2.77082 3.11924 2.77082 3.40617V3.98322C2.77082 4.27014 2.5382 4.50275 2.25127 4.50277C1.96436 4.50273 1.73172 4.27014 1.73172 3.98322V3.40617C1.73172 3.11925 1.96436 2.88665 2.25127 2.88662Z"
        fill="currentColor"
      />
      <path
        d="M2.25127 0C2.53812 2.11691e-05 2.7707 0.232726 2.77082 0.51955V1.0966C2.77082 1.38353 2.5382 1.61613 2.25127 1.61615C1.96436 1.61612 1.73172 1.38352 1.73172 1.0966V0.51955C1.73184 0.232734 1.96444 3.44275e-05 2.25127 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppFinancing(props: IconProps) {
  return (
    <svg
      viewBox="0 0 13.1619 10.276"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44689 4.61845C8.37147 4.61845 9.12122 5.3682 9.12122 6.29278C9.12109 7.21726 8.37139 7.96644 7.44689 7.96644C6.52248 7.96631 5.77335 7.21718 5.77323 6.29278C5.77323 5.36827 6.52241 4.61857 7.44689 4.61845ZM7.44689 5.65755C7.09629 5.65767 6.81233 5.94215 6.81233 6.29278C6.81245 6.64331 7.09636 6.92721 7.44689 6.92734C7.79751 6.92734 8.08199 6.64338 8.08212 6.29278C8.08212 5.94208 7.79759 5.65755 7.44689 5.65755Z"
        fill="currentColor"
      />
      <path
        d="M3.89189 5.94438C4.08382 5.73137 4.412 5.71411 4.62521 5.90582C4.83839 6.09779 4.8557 6.42658 4.66377 6.63982L4.65836 6.64591C4.46643 6.85905 4.13761 6.87629 3.92436 6.68447C3.71137 6.49257 3.69416 6.16436 3.8858 5.95115L3.89189 5.94438Z"
        fill="currentColor"
      />
      <path
        d="M10.2422 5.94438C10.4341 5.73137 10.7623 5.71411 10.9755 5.90582C11.1886 6.0978 11.2059 6.42661 11.0141 6.63982L11.0086 6.64591C10.8167 6.8591 10.4879 6.87623 10.2746 6.68447C10.0616 6.49254 10.0444 6.16436 10.2361 5.95115L10.2422 5.94438Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75577 0C10.6803 0 11.43 0.749846 11.4301 1.67433V2.30956H11.4876C12.4122 2.30956 13.1619 3.05931 13.1619 3.98389V8.60167C13.1618 9.52615 12.4121 10.276 11.4876 10.276H3.40617C2.48173 10.2759 1.73195 9.5261 1.73183 8.60167V7.96644H1.67433C0.749826 7.96634 0 7.21663 0 6.2921V1.67433C0.000114258 0.749902 0.749896 9.14042e-05 1.67433 0H9.75577ZM3.40617 3.34866C3.05554 3.34875 2.77093 3.63325 2.77093 3.98389V8.60167C2.77105 8.95222 3.05561 9.23681 3.40617 9.2369H11.4876C11.8382 9.2369 12.1227 8.95227 12.1228 8.60167V3.98389C12.1228 3.63319 11.8383 3.34866 11.4876 3.34866H3.40617ZM1.67433 1.0391C1.32378 1.03919 1.03921 1.32378 1.0391 1.67433V6.2921C1.0391 6.64275 1.32371 6.92724 1.67433 6.92734H1.73183V3.98389C1.73183 3.05937 2.48166 2.30965 3.40617 2.30956H10.391V1.67433C10.3909 1.32372 10.1064 1.0391 9.75577 1.0391H1.67433Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppConnections(props: IconProps) {
  return (
    <svg
      viewBox="0 0 6.81165 11.4301"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.32945 0C5.61639 0 5.849 0.232611 5.849 0.51955V2.20403C6.4237 2.53201 6.81162 3.14968 6.81165 3.85874V4.99526C6.81165 6.04737 5.95875 6.90028 4.90664 6.90028H3.92504V10.9106C3.9249 11.1974 3.69234 11.4301 3.40549 11.4301C3.11863 11.4301 2.88608 11.1974 2.88594 10.9106V6.90028H1.90502C0.852905 6.90028 0 6.04737 0 4.99526V3.85874C3.07854e-05 3.15001 0.387724 2.5328 0.96198 2.20471V0.51955C0.96198 0.232611 1.19459 0 1.48153 0C1.76847 0 2.00108 0.232611 2.00108 0.51955V1.95373H4.8099V0.51955C4.8099 0.232611 5.04251 0 5.32945 0ZM1.90502 2.99283C1.42681 2.99283 1.03915 3.38055 1.0391 3.85874V4.99526C1.0391 5.47349 1.42678 5.86118 1.90502 5.86118H4.90664C5.38487 5.86118 5.77255 5.47349 5.77255 4.99526V3.85874C5.77251 3.38055 5.38484 2.99283 4.90664 2.99283H1.90502Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppPerformance(props: IconProps) {
  return (
    <svg
      viewBox="0 0 11.4301 11.4301"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5642 0C11.0424 0 11.4301 0.387685 11.4301 0.865917V10.5642C11.4301 11.0424 11.0424 11.4301 10.5642 11.4301H0.865917C0.387685 11.4301 0 11.0424 0 10.5642V8.3703C0.000121727 7.89218 0.387759 7.50439 0.865917 7.50439H3.46367V4.32958C3.46367 3.85135 3.85135 3.46367 4.32958 3.46367H6.92734V0.865917C6.92734 0.387684 7.31502 0 7.79325 0H10.5642ZM1.0391 10.391H3.46367V8.54349H1.0391V10.391ZM4.50277 10.391H6.92734V4.50277H4.50277V10.391ZM7.96644 10.391H10.391V1.0391H7.96644V10.391Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function AppDocuments(props: IconProps) {
  return (
    <svg
      viewBox="0 0 11.4301 12.5849"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0146 1.73183C7.24422 1.73183 7.46445 1.82318 7.62683 1.98552L9.44458 3.80327C9.60685 3.96564 9.69827 4.18594 9.69827 4.4155V11.1994C9.69802 11.9644 9.07782 12.5849 8.3128 12.5849H1.38547C0.620447 12.5849 0.000247703 11.9644 0 11.1994V3.1173C3.39377e-08 2.35213 0.620294 1.73183 1.38547 1.73183H7.0146ZM1.38547 2.77093C1.19417 2.77093 1.0391 2.92601 1.0391 3.1173V11.1994C1.03935 11.3905 1.19433 11.5458 1.38547 11.5458H8.3128C8.50394 11.5458 8.65892 11.3905 8.65917 11.1994V5.07982H7.2162C6.73805 5.07982 6.35041 4.69203 6.35028 4.2139V2.77093H1.38547ZM7.38938 4.04072H8.21268L7.38938 3.21742V4.04072Z"
        fill="currentColor"
      />
      <path
        d="M8.41428 0.0101475C8.51419 0.0300953 8.60704 0.0791083 8.68014 0.152212L11.2779 2.74996C11.3753 2.84739 11.4301 2.97956 11.4301 3.1173V10.3335C11.4299 10.6202 11.1972 10.8529 10.9106 10.8531C10.6239 10.8529 10.3912 10.6202 10.391 10.3335V3.33243L8.09768 1.0391H2.82844C2.54168 1.03897 2.30901 0.806305 2.30889 0.51955C2.30889 0.232688 2.5416 0.000125692 2.82844 0H8.3128L8.41428 0.0101475Z"
        fill="currentColor"
      />
    </svg>
  );
}
